import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const track = (event_name, session_id = null, metadata = {}) => {
  try {
    api.post("/analytics/event", { event_name, session_id, metadata });
  } catch (e) {
    console.error("track failed", e);
  }
};

export function formatErr(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi ya.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}
